import React, { useCallback } from "react";
import { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BTable from 'react-bootstrap/Table';
import { HeaderList } from "../../../components/HeaderList";
import { DatasetDefault, DatasetModel } from "../../../models/dataset.model";
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { BranchService } from "../../../services/branch.service";
import { BranchModel } from "../../../models/branch.model";
import { EquipmentModel } from "../../../models/equipment.model";
import { EquipmentService } from "../../../services/equipment.service";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../../models/requestInputOutputParams.model";
import { HeadDateModel } from "../../../models/headDate.model";
import { EventExportService } from "../../../services/eventExport.service";
import { ForeCastService } from "../../../services/forecast.service";
import storageService from "../../../services/storage.service";
import UtilService from "../../../services/util.service";
import { useTable, usePagination, useSortBy } from 'react-table';
import { faSortAlphaUp, faSortAlphaDown, faSort } from "@fortawesome/free-solid-svg-icons";
import HelperService from "../../../services/helper.service";
import { ButtonClean, ButtonSearch, ButtonExport } from "../../../components/buttons";
import Pagination, { IPag, IPagination } from "../../../components/Pagination";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GroupModel } from "../../../models/group.model";
import GroupService from "../../../services/group.service";

function Table({columns, data, update, total_records, msgEmpty }) {
  let columnsToHidden = [];
  
  if (columns) {
    for (let i = 0; i < columns.length; i++) {
      const colFather = columns[i];
      if (colFather.columns) {
        for (let j = 0; j < colFather.columns.length; j++) {
          const colChild = colFather.columns[j];
          if (colChild.isVisible !== undefined && colChild.isVisible === false) {
            columnsToHidden.push(colChild.id || colChild.accessor);
          }
        }
      }
      else {
        if (colFather.isVisible !== undefined && colFather.isVisible === false) {
          columnsToHidden.push(colFather.id || colFather.accessor);
        }
      }
    }
  }


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: columnsToHidden
      },
    },
    useSortBy,
    usePagination
  )

  const formatCellStyleHeader = (cellInfo: any) => {
    const style: React.CSSProperties  = {
      border: 'none',
      color: '#2196F3',
      fontWeight: 700,
      textAlign: 'left',
      paddingLeft: '10px',
      width: cellInfo?.column?.width,
    };
    return style;
  }

  const formatCellStyle = (cellInfo: any) => {
    const style: React.CSSProperties = {
      width: cellInfo.column.width,
      height: '100%',
      padding: 2,
      wordBreak: 'break-word', // Garante quebra de linha no texto longo
      overflow: 'hidden' // Oculta o texto que ultrapassa o limite da célula
      
    };

    const columnId = cellInfo.column.id;
    let dayName = "";

    switch (columnId) {
      case "d01Value":
        dayName = "d01";
        break;
      case "d02Value":
        dayName = "d02";
        break;
      case "d03Value":
        dayName = "d03";
        break;
      case "d04Value":
        dayName = "d04";
        break;
      case "d05Value":
        dayName = "d05";
        break;
      case "d06Value":
        dayName = "d06";
        break;
      case "d07Value":
        dayName = "d07";
        break;
    }

    return style;
  }



  return (
    <div style={{ overflowX: 'auto' }}>
      <BTable hover size="sm" {...getTableProps()} style={{ width: '99.9%' }}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.filter(x => !x.columns).map(column => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={formatCellStyleHeader(column)}
                >
                  <div style={{ display: "inline-flex", alignItems: "center" }}>
                    <div style={{ display: "table-caption" }}>
                      {column.render('Header')}
                    </div>
                    {column.canSort
                      ? column.isSorted
                        ? <FontAwesomeIcon icon={column.isSortedDesc ? faSortAlphaDown : faSortAlphaUp} />
                        : <FontAwesomeIcon icon={faSort} />
                      : null
                    }
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row)
            const isUpdated = row.original.isUpdated;
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {

                  if (cell.column.id.indexOf("d01") !== -1 && !isUpdated) {
                    return <td
                      colSpan={7}
                      {...cell.getCellProps()}
                      style={{
                        background: "#fff",
                        textAlign: 'center',
                        verticalAlign: 'middle',
                        color: '#555',
                        padding: 0,
                        opacity: isUpdated ? 1 : 0.65
                      }}
                    >
                      <div style={formatCellStyle(cell)}>
                        {msgEmpty}
                      </div>
                    </td>
                  }

                  if (!isUpdated && cell.column.id.indexOf("d0") !== -1) {
                    return <></>;
                  }
                  return (
                    <td
                      {...cell.getCellProps()}
                      
                    >
                      <div style={formatCellStyle(cell)}>
                        {cell.render('Cell')}
                      </div>
                    </td>
                  )
                }
                )}
              </tr>
            )
          })}
        </tbody>
      </BTable>
    </div>
  );
}

const CollectionScheduleList = () => {
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const user = storageService.getUser();

  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'report_collection_schedule_forecast',
    filters: {
      branch_id: [],
      code_equipment: [], 
      date_start: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      date_end: moment().add(7, 'days').format('YYYY-MM-DD')
    },
    parameters: {}
  });

  const [datasetDashboardAnalytical, setDatasetDashboardAnalytical] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'report_collection_schedule_forecast',
    filters: {
      branch_id: [],
      code_equipment: [],
      date_start: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      date_end: moment().add(7, 'days').format('YYYY-MM-DD')
    },
    pagination: {
      page_number: 1,
      total_pages: 0,
      records_pages: 21,
      total_records: 0
    },
  });


  const [selectedDataDashboard, setSelectedDataDashboard] = useState(null);
  const [branches, setBranches] = useState<BranchModel[]>();
  const [codeEquipment, setCodeEquipment] = useState<string>();
  const [group, setGroup] = useState<GroupModel[]>();
  

  const getList = async (dataTable) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;
      pagination.page_number = dataTable.page_number;
      pagination.records_pages = 21;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = datasetDashboardAnalytical.pagination.page_number;
      pagination.records_pages = 21;
    }

    requestParams.parameters = {
      ...requestParams.parameters
    }

    const response: any = await ForeCastService.getCollectionScheduleList(requestParams);
    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'report_collection_schedule_forecast' }));
      setDatasetDashboardAnalytical(d);     
    }
    else {
      requestParams.datasets[0].data = null;
      setDatasetDashboardAnalytical(requestParams.datasets[0]);
    }

    setLoading(false);
  };

  const initialize = async () => {
    BranchService.getAllList().then((response: any) => {
      if(response.success){
        let branchList = response.result.datasets.filter((dataset)=>{return dataset.dataset === 'branch'});
        if (branchList[0].data != null)
        {
          const sort = branchList[0].data.sort((a, b) => a.fullName.localeCompare(b.fullName))
          setBranches(sort);
        }
        else
        setBranches([]);
      }else{
        setBranches([]);
      }
    });

    GroupService.getAll().then((response: any) => {
      if(response.success){
        let groupList = response.result;
        const sort = groupList.sort((a, b) => a.fullName.localeCompare(b.fullName)).filter(t=>t.inconsistentForecastAnalysis === true);
        setGroup(sort);
      }else{
        setGroup([]);
      }
    });

    await getList({
      page_number:1
    })
  };

  const handleSearch = async (event) => {
    if (event != null)
      event.preventDefault();
    await getList({
      page_number:1
    });
  };

  const [flagClear, setFlagClear] = useState(false);

  useEffect(() => {
        if (flagClear)
        {
            handleSearch(null);
            setFlagClear(false);
        }
      }, [flagClear]);

  const handleClean = () => {

    setDataset({ 
      ...dataset, 
      filters: { 
        branch_id: [], 
        code_equipment: [], 
        date_start: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        date_end: moment().add(7, 'days').format('YYYY-MM-DD') 
      } 
    });
    setDatasetDashboardAnalytical({ 
      ...datasetDashboardAnalytical, 
      filters: { 
        branch_id: [], 
        code_equipment: [], 
        date_start: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        date_end: moment().add(7, 'days').format('YYYY-MM-DD') 
      }
    });
    setCodeEquipment('');
    setFlagClear(true);
  
    // Set default dates for DatePicker
    setStartDate(moment().subtract(1, 'months').toDate());
    setEndDate(moment().add(7, 'days').toDate());
    setMaxDate(moment().add(7, 'days').toDate());
  };

  const exportFile = async () => { 
    getListExport(null);
  };

  const getListExport = async (dataTable) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;
      pagination.page_number = dataTable.page_number;
      pagination.records_pages = 21;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = datasetDashboardAnalytical.pagination.page_number;
      pagination.records_pages = 21;
    }

    requestParams.parameters = {
      ...requestParams.parameters
    }

    EventExportService.ExportCollectionScheduleForecast(requestParams).finally(() =>
      setLoading(false)
    );
  };

  const [maxDate, setMaxDate] = useState(moment().add(7, 'days').toDate())
  const calcMaxDate = (start, end) => {
    if (end)
      return moment().toDate();
    let startDate = moment(start).add(29, "day").toDate();    
    return moment().toDate() > (startDate) ? startDate : moment().toDate();
  }

  const [startDate, setStartDate] = useState(moment().add(-30, "day").toDate())
  const [endDate, setEndDate] = useState(moment().add(7, 'days').toDate())  
  const formatoData = user.locale.formatDate.replaceAll('DD', 'dd');
  const idiom = storageService.getIdiom();

  const data = React.useMemo(() => datasetDashboardAnalytical?.data || [], [ , datasetDashboardAnalytical?.data, selectedDataDashboard]);
  
  console.log("Data", data);

  const columns = React.useMemo(
    () => [
      {
        Header: t("INCONSISTENT.EQUIPMENT"),
        background: '#4b4b50',
        columns: [
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.SCHEDULING_DATE")}</span>),
              accessor: "programming_date",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (formatDateTime(props.value))
            },
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.BRANCH")}</span>),
              accessor: "regional",
              background: '#999999',
              disableSortBy: true,
              width: 50, 
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.EQUIPMENT")}</span>),
              accessor: "code_equipment",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.CONTRACTUAL_LIMIT_VALUE")}</span>),
              accessor: "contractual_limit_value",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (formatToCurrency(props.value))
            },
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.FORECAST_VALUE")}</span>),
              accessor: "current_forecast_value",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (formatToCurrency(props.value))
            },
            
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.COLLECT_PERCENTAGE")}</span>),
              accessor: "selected_collection_percentage",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.LIMITE_PHYSICAL")}</span>),
              accessor: "contractual_limit_physical_value",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.FORECAST_PHYSICAL_VALUE")}</span>),
              accessor: "current_forecast_value_physical",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (props.value)
            },
            
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.COLLECT_PERCENTAGE")}</span>),
              accessor: "selected_collection_percentage_physical",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.REGISTRATION_DATE")}</span>),
              accessor: "date_created",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (formatDateTime(props.value))
            },
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.JUSTIFICATION")}</span>),
              accessor: "justification",
              background: '#999999',
              disableSortBy: true,
              width: 550,
              Cell: props => (props.value)
            },
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.USER_NAME")}</span>),
              accessor: "operator_fullname",
              background: '#999999',
              disableSortBy: true,
              width: 150, 
              Cell: props => {
                // Função para pegar os dois primeiros nomes
                const getFirstTwoNames = (fullName) => {
                  if (!fullName) return '';
                  const names = fullName.split(' ');
                  return names.slice(0, 2).join(' ');
                };
                
                return getFirstTwoNames(props.value);
              }
            },
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.APPROVER")}</span>),
              accessor: "approver_fullname",
              background: '#999999',
              disableSortBy: true,
              width: 150, 
              Cell: props => {
                // Função para pegar os dois primeiros nomes
                const getFirstTwoNames = (fullName) => {
                  if (!fullName) return '';
                  const names = fullName.split(' ');
                  return names.slice(0, 2).join(' ');
                };
                
                return getFirstTwoNames(props.value);
              }
            },
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.DATE_APPROVED")}</span>),
              accessor: "approval_date",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: props => (formatDateTime(props.value))
            },
            {
              Header: props => (<span>{t("COLLECTION_SCHEDULE.STATUS")}</span>),
              accessor: "approved_rejected",
              background: '#999999',
              disableSortBy: true,
              width: 80, 
              Cell: ({ value, row }) => {
                const justification = row.original.justification;

                // Verificando a condição para 'Alerta Desligado' ou null
                if (justification === 'Alerta Desligado' || justification === null) {
                  return t("STATUS_PENDING_PICKUP_OFF"); // Tradução para 'Pendente - Alerta Desligado'
                }

                if (value === null) {
                  return t("STATUS_PENDING_PICKUP_MIN"); // Tradução para 'Pendente'
                }
                if (value === true) {
                  return t("STATUS_APPROVED_PICKUP_MIN"); // Tradução para 'Aprovado'
                }
                if (value === false) {
                  return t("STATUS_REJECT_PICKUP_MIN"); // Tradução para 'Reprovado'
                }
                return ''; // Caso nenhum dos valores esperados
              }
            },
        ]
      },
    ],
    []
  );

  const formatDateTime = (value) => {
    return UtilService.formatDate(value, user.locale.formatDate);
  };
  const formatToCurrency = (value) => {
    let decimalSeparator = user.locale?.decimalSeparator;
    let thousandSeparator = user.locale?.thousandSeparator;
    let moneyPrefix = user.locale?.moneyPrefix;
    return HelperService.number_format(value, 2, decimalSeparator, thousandSeparator);
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    
    <>
    <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <HeaderList title={t(`INCONSISTENT.TITLE_SUBOPTIMAL_COLLECTION_SCHEDULE`)} />
      </div>
      <Form>
        <Form.Label className="mb-1">{t("FILTERS")}</Form.Label>
        <Row className="align-items-center">
          <Col xs="auto">
              <DatePicker
                  onChange={(date) => {
                      const [ start, end] = date;

                      const retstart = (start== null ? null:moment(start).format('YYYY-MM-DD'));
                      const retend = (end== null ? null:moment(end).format('YYYY-MM-DD'));
                      console.log(retstart, retend);
                      const dateret = [];
                      dateret.push(retstart);
                      dateret.push(retend);


                      setDataset({ ...dataset, filters: { ...dataset.filters, date_begin_end: dateret } })
                      setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, date_begin_end: dateret } })
                      
                      setStartDate(start);
                      let newMaxDate = calcMaxDate(start, end);
                      let MaxDate = calcMaxDate(start, end);
                      newMaxDate = moment(newMaxDate).add(7, 'days').toDate();
                      setMaxDate(newMaxDate);
                      setEndDate(newMaxDate > end ? end : newMaxDate);                      

                  }}
                  maxDate={maxDate}
                  className={'form-control mr-3'}
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  dateFormat={formatoData}
                  isClearable={true}
                  locale={idiom.replaceAll('-', '').trim()}
                  disabled={(datasetDashboardAnalytical.filters.code_equipment[0] && datasetDashboardAnalytical.filters.code_equipment[0] != '')}
              />  
          </Col>
          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.branch_id.length > 0 ? dataset?.filters?.branch_id[0] : ''}
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, branch_id: [Number(e.target.value)] } })
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, branch_id: [Number(e.target.value)] } })
                  }}
                >
                  <option>{t("FILTER.SELECT")}</option>
                  {_.map(branches, (item: BranchModel) => {
                    return <option key={item.id} value={item.id}>{item.fullName}</option>
                  })}
                </Form.Control>
                <label>{t("FILTER.BRANCH")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>
          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  name='code_equipment'
                  id='code_equipment'
                  type='text'
                  placeholder={t(`EQUIPMENT.CODE_EQUIPMENT`)}
                  className='form-control'
                  value={codeEquipment}
                  onChange={(e) => {
                    setCodeEquipment(e.target.value.trim())
                    if (e.target.value.trim() !== '') {
                      setDataset({ ...dataset, filters: { ...dataset.filters, code_equipment: [e.target.value.trim()] } })
                      setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, code_equipment: [e.target.value.trim()] } })
                    } else {
                      setDataset({ ...dataset, filters: { ...dataset.filters, code_equipment: [] } })
                      setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, code_equipment: [] } })
                    }
                  }} 
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch(e);
                    }
                  }}
                  />
                <label>{t("FILTER.EQUIPMENT")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>
        </Row>  
        
        <Row className='mt-3'>
          <Col xs="auto">
            <ButtonSearch onClick={(e) => handleSearch(e)} isLoading={isLoading} />
          </Col>

          <Col xs="auto">
            <ButtonClean onClick={async (e) => handleClean()} isLoading={isLoading}/>
          </Col>

          <Col xs="auto">
            <ButtonExport onClick={() => exportFile()} isLoading={isLoading}/>
          </Col>



        </Row>
      </Form>
      <Row className="align-items-center pb-3">
        <Col sm={12}>          
          <Table
            data={data}
            columns={columns}
            update={null}
            total_records={21}
            msgEmpty={t('DASHBOARD.IS_NOT_UPDATED')} />
        </Col>
      </Row>
    </>
  );
};

export default CollectionScheduleList;
